export { genCollapseMotion } from 'antd/es/style/motion';